<div class="rec">
  <header class="rec-header">
    <h1>Recordatorio de inactividad</h1>
    <span class="rec-estado" *ngIf="resumen" [class.on]="resumen.encendido">
      {{ resumen.encendido ? 'Encendido' : 'Apagado' }}
    </span>
  </header>

  <p class="rec-nota">
    El día 1 de cada mes a las 10:00 sale un correo a todos los clientes aprobados que ya
    operaron, llevan más de {{ resumen?.criterio?.diasSinOperar || 30 }} días sin operar y no
    se conectaron en {{ resumen?.criterio?.diasSinConexion || 30 }} días. Se les deja de
    escribir después de {{ resumen?.criterio?.maxMesesSeguidos || 3 }} meses seguidos sin
    respuesta. Sale solo: no se envía a mano.
  </p>

  <div class="rec-aviso-entorno" *ngIf="resumen?.soloProd">
    Estás en un entorno que no es producción: acá el recordatorio nunca envía, aunque esté encendido.
  </div>

  <div class="rec-cargando" *ngIf="cargando">Cargando…</div>
  <div class="rec-error" *ngIf="error">{{ error }}</div>
  <div class="rec-ok" *ngIf="aviso">{{ aviso }}</div>

  <ng-container *ngIf="resumen && !cargando">
    <div class="rec-nums">
      <div class="rec-num">
        <span class="rec-num-label">Próximo envío</span>
        <span class="rec-num-valor">{{ resumen.proximaCorrida | date: 'dd/MM/yy HH:mm' }}</span>
        <span class="rec-num-sub">{{ estadoCorrida() }}</span>
      </div>
      <div class="rec-num">
        <span class="rec-num-label">Lo recibirían hoy</span>
        <span class="rec-num-valor">{{ resumen.candidatosHoy | number }}</span>
        <span class="rec-num-sub">clientes que cumplen el criterio</span>
      </div>
      <div class="rec-num">
        <span class="rec-num-label">Bajas</span>
        <span class="rec-num-valor">{{ resumen.bajasTotal | number }}</span>
        <span class="rec-num-sub">en total</span>
      </div>
    </div>

    <div class="rec-acciones">
      <div class="rec-bloque">
        <h3>Encender o apagar</h3>
        <ng-container *ngIf="!confirmando">
          <button class="rec-btn" [class.peligro]="resumen.encendido" [disabled]="ocupado" (click)="pedirInterruptor()">
            {{ resumen.encendido ? 'Apagar' : 'Encender' }}
          </button>
          <p class="rec-ayuda">Apagarlo corta también un envío que esté en curso.</p>
        </ng-container>
        <div class="rec-confirmar" *ngIf="confirmando">
          <span *ngIf="confirmando === 'encender'">
            El día 1 le llega a los {{ resumen.candidatosHoy | number }} que califican hoy. ¿Encender?
          </span>
          <span *ngIf="confirmando === 'apagar'">No se enviará nada hasta volver a encenderlo. ¿Apagar?</span>
          <button class="rec-btn" [disabled]="ocupado" (click)="confirmarInterruptor()">
            Sí, {{ confirmando === 'encender' ? 'encender' : 'apagar' }}
          </button>
          <button class="rec-btn secundario" [disabled]="ocupado" (click)="confirmando = null">Cancelar</button>
        </div>
      </div>

      <div class="rec-bloque">
        <h3>Correo de prueba</h3>
        <button class="rec-btn secundario" [disabled]="ocupado" (click)="enviarPrueba()">Enviarme la prueba</button>
        <p class="rec-ayuda">Te llega a tu casilla con datos de ejemplo. No cuenta como envío.</p>
      </div>

      <div class="rec-bloque">
        <h3>Dar de baja a un cliente</h3>
        <div class="rec-campos">
          <input
            aria-label="Correo del cliente"
            type="email"
            placeholder="cliente@correo.com"
            [(ngModel)]="emailBaja"
            (keyup.enter)="darDeBaja()"
          />
          <button class="rec-btn" [disabled]="ocupado || !emailBaja.trim()" (click)="darDeBaja()">Dar de baja</button>
        </div>
        <p class="rec-ayuda">Para quien lo pidió por WhatsApp u otro canal.</p>
      </div>
    </div>

    <nav class="rec-tabs">
      <button [class.on]="pestana === 'meses'" (click)="cambiarPestana('meses')">Por mes</button>
      <button [class.on]="pestana === 'envios'" (click)="cambiarPestana('envios')">Envíos</button>
      <button [class.on]="pestana === 'bajas'" (click)="cambiarPestana('bajas')">Bajas</button>
    </nav>

    <!-- ======================================================== Por mes -->
    <ng-container *ngIf="pestana === 'meses'">
      <div class="rec-vacio" *ngIf="!resumen.meses.length">Todavía no se envió ningún recordatorio.</div>
      <div class="rec-tabla-wrap" *ngIf="resumen.meses.length">
        <table class="rec-tabla">
          <thead>
            <tr>
              <th>Mes</th>
              <th>Enviados</th>
              <th>Volvieron a operar (14 días)</th>
              <th>Bajas</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of resumen.meses">
              <td>{{ m.ciclo }}</td>
              <td>{{ m.enviados | number }}</td>
              <td>
                {{ m.volvieron14d | number }}
                <span class="rec-pct" *ngIf="pctVolvieron(m) !== null">({{ pctVolvieron(m) }}%)</span>
              </td>
              <td>{{ m.bajas | number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- ======================================================== Envios -->
    <ng-container *ngIf="pestana === 'envios'">
      <div class="rec-buscar">
        <input
          aria-label="Buscar envíos"
          type="search"
          placeholder="Buscar por correo o nombre"
          [(ngModel)]="envios.q"
          (keyup.enter)="cargarEnvios(1)"
        />
        <button class="rec-btn secundario" (click)="cargarEnvios(1)">Buscar</button>
      </div>

      <div class="rec-cargando" *ngIf="envios.cargando">Cargando…</div>
      <ng-container *ngIf="!envios.cargando">
        <div class="rec-vacio" *ngIf="!envios.items.length">No hay envíos{{ envios.q ? ' que coincidan' : '' }}.</div>
        <div class="rec-tabla-wrap" *ngIf="envios.items.length">
          <table class="rec-tabla">
            <thead>
              <tr>
                <th>Enviado</th>
                <th>Cliente</th>
                <th>Correo</th>
                <th>Volvió a operar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of envios.items">
                <td>{{ e.enviadoAt | date: 'dd/MM/yy HH:mm' }}</td>
                <td>{{ e.nombre }}</td>
                <td>{{ e.email }}</td>
                <td><span class="rec-si" [class.on]="e.volvio">{{ e.volvio ? 'Sí' : 'No' }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rec-paginado" *ngIf="envios.total > porPagina">
          <button [disabled]="envios.page <= 1" (click)="cargarEnvios(envios.page - 1)">Anterior</button>
          <span>{{ envios.page }} de {{ totalPaginas(envios) }} · {{ envios.total | number }} envíos</span>
          <button [disabled]="envios.page >= totalPaginas(envios)" (click)="cargarEnvios(envios.page + 1)">Siguiente</button>
        </div>
      </ng-container>
    </ng-container>

    <!-- ======================================================== Bajas -->
    <ng-container *ngIf="pestana === 'bajas'">
      <div class="rec-buscar">
        <input
          aria-label="Buscar bajas"
          type="search"
          placeholder="Buscar por correo o nombre"
          [(ngModel)]="bajas.q"
          (keyup.enter)="cargarBajas(1)"
        />
        <button class="rec-btn secundario" (click)="cargarBajas(1)">Buscar</button>
      </div>

      <div class="rec-cargando" *ngIf="bajas.cargando">Cargando…</div>
      <ng-container *ngIf="!bajas.cargando">
        <div class="rec-vacio" *ngIf="!bajas.items.length">No hay bajas{{ bajas.q ? ' que coincidan' : '' }}.</div>
        <div class="rec-tabla-wrap" *ngIf="bajas.items.length">
          <table class="rec-tabla">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Correo</th>
                <th>Por</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let b of bajas.items">
                <td>{{ b.createdAt | date: 'dd/MM/yy HH:mm' }}</td>
                <td>{{ b.nombre }}</td>
                <td>{{ b.email }}</td>
                <td>{{ origenBaja(b.origen) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rec-paginado" *ngIf="bajas.total > porPagina">
          <button [disabled]="bajas.page <= 1" (click)="cargarBajas(bajas.page - 1)">Anterior</button>
          <span>{{ bajas.page }} de {{ totalPaginas(bajas) }} · {{ bajas.total | number }} bajas</span>
          <button [disabled]="bajas.page >= totalPaginas(bajas)" (click)="cargarBajas(bajas.page + 1)">Siguiente</button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
